import { Component, computed, input } from "@angular/core";
import { WirelessHealthDetail } from "../../../gql/generated";
import { KpiItem, KPI_ITEMS_AEROHIVE, KPI_ITEMS_ARUBA } from "../../../helpers/kpi/kpi-item";
import { KpiData } from "./components/kpi-data/kpi-data";

@Component({
  selector: "kpi-table",
  templateUrl: "kpi-table.html",
  styleUrls: ["kpi-table.scss"],
  imports: [KpiData],
})
export class KpiTableComponent {
  readonly wirelessHealthData = input.required<WirelessHealthDetail>();
  readonly vendor = input.required<string>();

  protected kpiItems = computed(() => {
    const vendor: string = this.vendor().toLowerCase().trim().replace(" ", "-");
    if (vendor === "aerohive") {
      return KPI_ITEMS_AEROHIVE;
    } else if (vendor === "aruba") {
      return KPI_ITEMS_ARUBA;
    } else {
      console.warn(`Unknown wifi vendor: ${vendor}.`);
      return [];
    }
  });

  protected kpiRowsLeft = computed(() => this.getKpiData(this.wirelessHealthData(), this.kpiItems(), "twofour"));
  protected kpiRowsRight = computed(() => this.getKpiData(this.wirelessHealthData(), this.kpiItems(), "five"));

  getKpiData(wirelessHealthData: WirelessHealthDetail, kpiItems: KpiItem[], frequency: "twofour" | "five") {
    const kpiMoments = {
      today: 1,
      last3Days: 3,
      lastWeek: 7,
    };

    return Object.entries(kpiMoments).map(([momentName, numDays]) => {
      const extractKpiMoment = (kpiItem: KpiItem) => {
        const kpiValue = wirelessHealthData[momentName][frequency][kpiItem.key];
        const value = !kpiItem.percentage ? parseFloat(kpiValue).toFixed(2) : kpiValue;

        return { value: value as number, kpi: kpiItem };
      };

      const kpiMomentData = kpiItems.map(extractKpiMoment);
      return { days: numDays, values: kpiMomentData };
    });
  }
}
